<div class="flex content-center gap-2">
    <div class=" flex items-center" *ngIf="FilterFields.modified">
        <mat-form-field
            appearance="fill"
            matTooltip="Date Modified"
            class="file-manager-filter-select-time w-full fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2">
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_outline:clock'"
                matPrefix
            ></mat-icon>
            <mat-select
                [(ngModel)]="dateRange"
                (ngModelChange)="onFilterChange()"
                [placeholder]="'Date Modified'">
                <mat-option [value]="'any'">Any</mat-option>
                <mat-option [value]="'today'">Today</mat-option>
                <mat-option [value]="'yesterday'">Yesterday</mat-option>
                <mat-option [value]="'last7'">Last 7 days</mat-option>
                <mat-option [value]="'last30'">Last 30 days</mat-option>
                <mat-option [value]="'last90'">Last 90 days</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!--filter by file type-->
    <div class=" flex items-center" *ngIf="FilterFields.fileType">
        <mat-form-field
            class="file-manager-filter-select-type w-full fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2"
            matTooltip="File Type">
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_outline:document-check'"
                matPrefix></mat-icon>
            <mat-select
                [placeholder]="'Type'"
                [(ngModel)]="assestFilter.fileType"
                (ngModelChange)="onFilterChange()">
                <mat-option [value]="'any'">
                    <mat-icon [svgIcon]="'heroicons_outline:document-check'"></mat-icon>
                    Any
                </mat-option>
                <ng-container *ngFor="let fileType of fileTypes">
                    <mat-option [value]="fileType.type">
                        <mat-icon
                            [svgIcon]="util.getFileTypeImage(fileType.icon)"
                        ></mat-icon>
                        {{ fileType.label }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Filter by Labels -->
    <div class=" flex items-center" *ngIf="FilterFields.label">
        <mat-form-field
            matTooltip="Labels"
            class="file-manager-filter-select-type w-full fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2">
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_outline:tag'"
                matPrefix
            ></mat-icon>

            <mat-select
                [(ngModel)]="label"
                (ngModelChange)="onFilterChange()"
                [placeholder]="'Labels'">
                <mat-option [value]="'any'">Any</mat-option>
                <ng-container *ngFor="let label of labels">
                    <mat-option
                        [ngClass]="labelColors[label.color].combined"
                        [value]="label.id">
                        {{ label.name }}
                    </mat-option>
                </ng-container>
                <!-- Add more label options here -->
            </mat-select>
        </mat-form-field>
    </div>

        <!-- Filter by Favorite -->
        <div class=" flex items-center" *ngIf="FilterFields.starred">
            <mat-form-field
                matTooltip="Favorite"
                class="file-manager-filter-select-type w-full fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2">
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:star'"
                    matPrefix
                ></mat-icon>
    
                <mat-select
                    [(ngModel)]="favourite"
                    (ngModelChange)="onFilterChange()"
                    [placeholder]="'Favorite'">
                    <mat-option [value]="'all'">Show All</mat-option>
                    <mat-option [value]="true">Favorite Only</mat-option>
                    <mat-option [value]="false">Hide Favorite</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    
    <div class="w-4/12 items-center" *ngIf="FilterFields.user">
        <div class="relative file-manager-filter-select-type w-full fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2">
            <div class="absolute rounded-s-3xl  fuse-mat-emphasized-affix w-12 inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:user'"
                    matPrefix>
                </mat-icon>
            </div>
            <input
                (focus)="onInputFocus()" (blur)="onInputBlur()" 
                [(ngModel)]="userInput"
                (ngModelChange)="onValueChanged($event)"
                [matAutocomplete]="auto"
                type="text"
                id="user-search"
                class="bg-white border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-blue-500 focus:border-blue-500 block w-full ps-13 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Shared With..." />
            <button
                *ngIf="assestFilter.sharedWithId || userInput"
                type="button"
                (click)="clearUserSearch()"
                class="absolute inset-y-0 end-0 flex items-center pe-3">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
            <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                [displayWith]="displayFn">
                @for (option of itemsList; track option) {
                    <mat-option [value]="option">{{ option.email }}</mat-option>
                }
            </mat-autocomplete>
        </div>
    </div>
</div>
